const TRANSITION = "all .3s ease-in-out";

export { TRANSITION };
